module.exports = __webpack_public_path__ + "img/product_27.449a3ae.jpg";